export default __webpack_public_path__ + "static/media/menupfad_step2_arab.1b67cf9f.svg";